export const MAX_SIZE_FILE_10_MB = 10240000;
